const stickyHeader = {
    init: () => {
        const header = document.querySelector('.localads-header-top');
        if (!header) return;

        let ticking = false;

        const update = () => {
            const isScrolled = window.scrollY > 80;
            header.classList.toggle('is-scrolled-down', isScrolled);
            document.body.classList.toggle('is-scrolled', isScrolled);
            ticking = false;
        };

        window.addEventListener('scroll', () => {
            if (!ticking) {
                window.requestAnimationFrame(update);
                ticking = true;
            }
        }, { passive: true });

        update();
    }
};

export default stickyHeader;